import { Stack, StackOwnProps } from "@mui/material";
import {
  GridToolbarColumnsButton,
  GridToolbarContainer,
  GridToolbarFilterButton,
  GridToolbarQuickFilter
} from "@mui/x-data-grid";
import { ExportCsvButton } from "../ExportCsvButton";
import { CustomToolbarProps } from "../Interfaces/CustomDataGrid.interfaces";

export const CustomDataGridToolbar = ({
  exportCsvButtonProps,
  filterModel,
  toolbarConfig = {}
}: CustomToolbarProps) => {
  const filterCount = filterModel.items.length;

  const stackProps: StackOwnProps = {
    alignItems: "center",
    direction: "row",
    justifyContent: "space-between",
    spacing: 1,
    width: "100%"
  };
  const {
    disableGridToolbarColumnsButton = false,
    disableGridToolbarExport = false,
    disableGridToolbarFilterButton = false,
    disableGridToolbarQuickFilter = false
  } = toolbarConfig;

  if (
    disableGridToolbarColumnsButton &&
    disableGridToolbarFilterButton &&
    disableGridToolbarExport &&
    disableGridToolbarQuickFilter
  ) {
    return null;
  }

  return (
    <GridToolbarContainer>
      <Stack {...stackProps}>
        <Stack direction="row" gap={1}>
          {!disableGridToolbarColumnsButton && <GridToolbarColumnsButton />}
          {!disableGridToolbarFilterButton && (
            <GridToolbarFilterButton
              slotProps={{
                badge: {
                  invisible: filterCount === 0,
                  badgeContent: filterCount
                }
              }}
            />
          )}
          {!disableGridToolbarExport && <ExportCsvButton {...exportCsvButtonProps} />}
        </Stack>
        <div>{!disableGridToolbarQuickFilter && <GridToolbarQuickFilter debounceMs={1000} />}</div>
      </Stack>
    </GridToolbarContainer>
  );
};
